import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { TIMETABLE } from '../../../shared/utils/constants';

const DroppableDiscipline = (props) => {
  const { list } = props;

  return (
    <Droppable
      droppableId={TIMETABLE.DISCIPLINE}
      direction="horizontal"
      isDropDisabled
    >
      {(provided) => (
        <div ref={provided.innerRef} className="draggable-card-container">
          <div className="d-flex">
            {list.length
              ? list.every((item) => item.professor && item.room) &&
                list.map((item, index) => (
                  <Draggable
                    key={item.subject.id}
                    draggableId={String(item.subject.id)}
                    index={index}
                    isDragDisabled={item.restStep === 0}
                  >
                    {(providedx, snapshotx) => (
                      <>
                        <div
                          ref={providedx.innerRef}
                          {...providedx.draggableProps}
                          {...providedx.dragHandleProps}
                          className={`draggable-card ${
                            item.restStep === 0 ? 'complete' : 'un-complete'
                          }`}
                        >
                          <div className="d-flex justify-content-between p-1">
                            <span className="label">{item.subject.name}</span>
                            <span
                              className={`badge-content ${
                                item.restStep === 0 ? 'complete' : 'un-complete'
                              }`}
                            >
                              {item.restStep}/{item.stepWorkLoad}
                            </span>
                          </div>
                          <span className="info-content">
                            {item.professor.name}
                          </span>
                          <span className="info-content">{item.room.name}</span>
                        </div>
                        {snapshotx.isDragging && (
                          <div
                            className={`draggable-card-clone ${
                              item.restStep === 0 ? 'complete' : 'un-complete'
                            }`}
                          >
                            <div className="d-flex justify-content-between p-1">
                              <span className="label">{item.subject.name}</span>
                              <span
                                className={`badge-content ${
                                  item.restStep === 0
                                    ? 'complete'
                                    : 'un-complete'
                                }`}
                              >
                                {item.restStep}/{item.stepWorkLoad}
                              </span>
                            </div>
                            <span className="info-content">
                              {item.professor.name}
                            </span>
                            <span className="info-content">
                              {item.room.name}
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </Draggable>
                ))
              : null}
          </div>
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

DroppableDiscipline.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
};

export default withTranslation('common')(DroppableDiscipline);
